import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import type { UboResponse } from '@Store/index';

export interface OwnersCenterContextValue {
  businessOwners: UboResponse[];
  mainOwner: UboResponse;
  onEditClick: (uboId: string) => void;
  onAddClick: () => Promise<void>;
  handleMainOwnerPercentageChange: (value: number | null) => void;
  validateTotalPercentage: () => void;
}

const OwnersCenterContext = createContext<OwnersCenterContextValue | null>(null);

export const useOwnersCenterContext = (): OwnersCenterContextValue => {
  const context = useContext(OwnersCenterContext);
  if (!context) {
    throw new Error('useOwnersCenterContext must be used within an OwnersCenterProvider');
  }
  return context;
};

interface OwnersCenterProviderProps {
  value: OwnersCenterContextValue;
  children: ReactNode;
}

export const OwnersCenterProvider = ({ value, children }: OwnersCenterProviderProps) => (
  <OwnersCenterContext.Provider value={value}>{children}</OwnersCenterContext.Provider>
);
